'use client';

import Link from 'next/link';
import { Button } from '../../../ui/button';
import {
  ChevronDown,
  ArrowRightCircleIcon,
  UserPlusIcon,
  UserIcon,
  HousePlusIcon,
} from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { NavbarCurrencySwitcher } from '../../Utilities/NavbarCurrencySwitcher';
import { Separator } from '@/components/ui/separator';
import { SignInButton, SignUpButton } from '@clerk/nextjs';
import { cn } from '@/lib/utils';

export default function SignedOutMobileLinks({ color }: { color: 'black' | 'white' }) {
  const backgroundColor = color === 'black' ? 'bg-primary' : 'bg-white';
  const borderStyle = color === 'black' ? ' border-primary' : 'border-white';
  const textColor = color === 'black' ? 'text-black' : 'text-white';

  const navbarGradient =
    color !== 'black'
      ? 'bg-transparent/15 backdrop-blur-md border border-white text-shadow-sm'
      : 'bg-gradient-to-b from-secondary via-brand-blue to-accent border-none text-shadow-sm';

  return (
    <div className="flex flex-row gap-1 justify-between items-center">
      <div
        className={cn(
          'flex flex-row gap-2 justify-between items-center rounded-full px-2 border-2',
          borderStyle
        )}
      >
        <NavbarCurrencySwitcher color={color} variant="ghost" />
        <Separator
          orientation="vertical"
          className={cn('h-4 w-px font-bold transition-colors duration-300', backgroundColor)}
        />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              size="sm"
              variant="ghost"
              className={cn('gap-1 rounded-full shadow-sm font-bold')}
            >
              <UserIcon
                className={cn('h-4 w-4 transition-colors duration-300', textColor)}
                strokeWidth={3}
              />
              <span className="sr-only sm:not-sr-only">Account</span>
              <ChevronDown
                className={cn('h-4 w-4 transition-colors duration-300', textColor)}
                strokeWidth={3}
              />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className={cn('mt-2 w-52 rounded-lg ', borderStyle, navbarGradient)}
          >
            <DropdownMenuItem asChild>
              <SignInButton>
                <div className="flex items-center">
                  <ArrowRightCircleIcon
                    className={cn('mr-2 h-4 w-4 transition-colors duration-300', textColor)}
                  />
                  <span className={cn('font-bold', textColor)}>Log in</span>
                </div>
              </SignInButton>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <SignUpButton forceRedirectUrl={'/host'}>
                <div className="flex items-center">
                  <UserPlusIcon
                    className={cn('mr-2 h-4 w-4 transition-colors duration-300', textColor)}
                  />
                  <span className={cn('font-bold', textColor)}>Create Account</span>
                </div>
              </SignUpButton>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link href="/hosting">
                <div className="flex items-center">
                  <HousePlusIcon
                    className={cn(
                      'mr-2 h-4 w-4 transition-colors duration-300 text-shadow-lg',
                      textColor
                    )}
                  />
                  <span className={cn('font-bold', textColor)}>Add Your Property</span>
                </div>
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
